import React from 'react';

const Hero = () => {
  return (
    <div className="hero-container" id="hero">
      <div className="hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <h1 style={{ color: '#f4f4f4', fontSize: '3.5rem', fontWeight: '700', lineHeight: '1.2' }}>
                Transforming Data into Direction
              </h1>
              <p style={{ color: '#f4f4f4', fontSize: '1.2rem', marginTop: '25px', lineHeight: '1.8', maxWidth: '600px', opacity: '0.9' }}>
                We don't just deliver reports, we unlock potential. Whether you're looking to scale, streamline, or solve, we turn your data into clarity, action, and measurable growth.
              </p>
              <div style={{ marginTop: '35px', textAlign: 'left' }}>
                <a href="#contact" className="btn-theme">
                See what's possible
                  <svg className="button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true">
                    <defs>
                      <linearGradient id="gradient1-hero" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#F4D03F"/>
                        <stop offset="100%" stopColor="#E5A500"/>
                      </linearGradient>
                      <linearGradient id="gradient2-hero" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#FF9F45"/>
                        <stop offset="100%" stopColor="#D9643A"/>
                      </linearGradient>
                      <linearGradient id="gradient3-hero" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#7EA8DE"/>
                        <stop offset="100%" stopColor="#4A69BB"/>
                      </linearGradient>
                      <linearGradient id="gradient4-hero" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#70C770"/>
                        <stop offset="100%" stopColor="#26A65B"/>
                      </linearGradient>
                    </defs>
                    <rect rx="12" ry="12" x="40" y="50" width="180" height="75" fill="url(#gradient1-hero)" stroke="white" strokeWidth="2"/>
                    <rect rx="12" ry="12" x="40" y="135" width="250" height="75" fill="url(#gradient2-hero)" stroke="white" strokeWidth="2"/>
                    <rect rx="12" ry="12" x="40" y="220" width="315" height="75" fill="url(#gradient3-hero)" stroke="white" strokeWidth="2"/>
                    <rect rx="12" ry="12" x="40" y="305" width="215" height="75" fill="url(#gradient4-hero)" stroke="white" strokeWidth="2"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="col-lg-5 d-none d-lg-flex justify-content-center hero-illustration">
              <img 
                src="/assets/img/illustration/18.png" 
                alt="Hero Illustration" 
                style={{ transform: "scaleX(-1)", maxWidth: '100%', height: 'auto' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
